import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";

type InfoBlockHeadingProps = {
    title: string;
    onClick: () => void;
};

const InfoBlockHeading = ({ title, onClick }: InfoBlockHeadingProps) => {
    return (
        <section className={cn("info-block__heading")}>
            <Row>
                <Col>
                    <Button
                        type="button"
                        className={cn(
                            "info-block__heading-button",
                            "tw:flex tw:flex-row tw:text-left tw:p-0 tw:hover:no-underline tw:focus:no-underline tw:active:no-underline tw:group"
                        )}
                        color="link"
                        fullWidth
                        onClick={onClick}
                    >
                        <div className={cn("tw:grow")}>
                            <h4
                                className={cn(
                                    "tw:my-4! tw:block tw:group-hover:underline tw:group-focus:underline tw:group-active:underline"
                                )}
                            >
                                {title}
                            </h4>
                        </div>
                        <div
                            className={cn(
                                "tw:my-4 tw:block tw:font-bold tw:text-lg"
                            )}
                        >
                            <i
                                className={cn(
                                    "tw:inline tw:group-[.info-block--active]/info-block:hidden las la-plus"
                                )}
                            ></i>
                            <i
                                className={cn(
                                    "tw:hidden tw:group-[.info-block--active]/info-block:inline las la-minus"
                                )}
                            ></i>
                        </div>
                    </Button>
                </Col>
            </Row>
        </section>
    );
};

export { InfoBlockHeading };
